module.exports = __webpack_public_path__ + "img/baselinker.dbab0f3a.png";